import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInterceptor from 'src/app/axiosInterceptor';
import { _convertObjectToQuery } from 'src/app/utils/apiService';
import { showGlobalToast } from 'src/features/uiSlice';
import { messageToastType_const } from 'src/app/constant/config';

export const getListReceipts = createAsyncThunk(
  'receiptSlice/getListReceipts',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axiosInterceptor.get(`/receipt?${_convertObjectToQuery(params)}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const createReceipt = createAsyncThunk(
  'receiptSlice/createReceipt',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await axiosInterceptor.post('/receipt', data);
      dispatch(showGlobalToast({ message: 'Tạo phiếu thu tiền thành công!', type: messageToastType_const.success }));
      return response.data;
    } catch (err) {
      const errMsg = err.response?.data?.message || 'Tạo phiếu thu tiền thất bại!';
      dispatch(showGlobalToast({ message: errMsg, type: messageToastType_const.error }));
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateReceipt = createAsyncThunk(
  'receiptSlice/updateReceipt',
  async ({ id, data }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axiosInterceptor.put(`/receipt/${id}`, data);
      dispatch(showGlobalToast({ message: 'Cập nhật phiếu thu thành công!', type: messageToastType_const.success }));
      return response.data;
    } catch (err) {
      const errMsg = err.response?.data?.message || 'Cập nhật phiếu thu thất bại!';
      dispatch(showGlobalToast({ message: errMsg, type: messageToastType_const.error }));
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteReceipt = createAsyncThunk(
  'receiptSlice/deleteReceipt',
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await axiosInterceptor.delete(`/receipt/${id}`);
      dispatch(showGlobalToast({ message: 'Đã xóa phiếu thu!', type: messageToastType_const.info }));
      return { id, res: response.data };
    } catch (err) {
      const errMsg = err.response?.data?.message || 'Xóa phiếu thu thất bại!';
      dispatch(showGlobalToast({ message: errMsg, type: messageToastType_const.error }));
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const receiptSlice = createSlice({
  name: 'receiptSlice',
  initialState: {
    listReceipts: [],
    totalReceipts: 0,
    totalAmountSum: 0,
    agencyOrderTotalAmount: undefined,
    agencyOrderCount: undefined,
    page: 1,
    pageSize: 20,
    isLoading: false,
    error: null,
    statusCreate: null,
    statusUpdate: null,
    statusDelete: null
  },
  reducers: {
    resetChange: (state) => {
      state.statusCreate = null;
      state.statusUpdate = null;
      state.statusDelete = null;
      state.error = null;
    }
  },
  extraReducers: {
    [getListReceipts.pending]: (state) => {
      state.isLoading = true;
    },
    [getListReceipts.fulfilled]: (state, action) => {
      state.isLoading = false;
      const payload = action.payload?.payload || {};
      state.listReceipts = payload.receipts || payload.data || [];
      state.totalReceipts = action.payload?.numberOfItem ?? state.listReceipts.length;
      state.totalAmountSum = action.payload?.total_amount_sum ?? 0;
      state.agencyOrderTotalAmount = action.payload?.agency_order_total_amount;
      state.agencyOrderCount = action.payload?.agency_order_count;
      state.page = action.payload?.page ?? 1;
      state.pageSize = action.payload?.page_size ?? 20;
    },
    [getListReceipts.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    [createReceipt.pending]: (state) => {
      state.statusCreate = 'PENDING';
    },
    [createReceipt.fulfilled]: (state) => {
      state.statusCreate = 'SUCCESS';
    },
    [createReceipt.rejected]: (state, action) => {
      state.statusCreate = 'ERROR';
      state.error = action.payload;
    },
    [updateReceipt.pending]: (state) => {
      state.statusUpdate = 'PENDING';
    },
    [updateReceipt.fulfilled]: (state) => {
      state.statusUpdate = 'SUCCESS';
    },
    [updateReceipt.rejected]: (state, action) => {
      state.statusUpdate = 'ERROR';
      state.error = action.payload;
    },
    [deleteReceipt.pending]: (state) => {
      state.statusDelete = 'PENDING';
    },
    [deleteReceipt.fulfilled]: (state) => {
      state.statusDelete = 'SUCCESS';
    },
    [deleteReceipt.rejected]: (state, action) => {
      state.statusDelete = 'ERROR';
      state.error = action.payload;
    }
  }
});

export const { resetChange } = receiptSlice.actions;
export default receiptSlice.reducer;
